import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './Navbar.css'

const HERO_ROUTES = new Set(['/', '/services'])

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const { pathname } = useLocation()
  const overHero = HERO_ROUTES.has(pathname)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    if (!menuOpen) return undefined

    const onKey = (e) => {
      if (e.key === 'Escape') setMenuOpen(false)
    }
    document.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'

    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
    }
  }, [menuOpen])

  const closeMenu = () => setMenuOpen(false)
  const toggleMenu = () => setMenuOpen((open) => !open)
  const solid = scrolled || menuOpen || !overHero
  const logoSrc = solid ? '/logo-nav.svg' : '/logo-nav-on-dark.svg'

  return (
    <nav className={`navbar${solid ? ' navbar--solid' : ''}`} aria-label="Primary">
      <div className="navbar-inner">
        <Link to="/" className="logo-link" onClick={closeMenu}>
          <img src={logoSrc} alt="Konsri Technologies" className="navbar-logo" />
        </Link>

        <button
          type="button"
          className={`hamburger${menuOpen ? ' open' : ''}`}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          aria-controls="primary-nav"
          onClick={toggleMenu}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        {menuOpen && <div className="navbar-overlay" onClick={closeMenu} aria-hidden="true" />}

        <div
          id="primary-nav"
          className={`navbar-links${menuOpen ? ' open' : ''}`}
        >
          <a
            href="https://finq.in"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
            onClick={closeMenu}
          >
            FinQ
          </a>
          <Link to="/services" className="nav-link" onClick={closeMenu}>
            Services
          </Link>
          <a href="/#contact" className="nav-link nav-link--cta" onClick={closeMenu}>
            Contact
          </a>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
